import { render, staticRenderFns } from "./ConfHiopos.vue?vue&type=template&id=28d6b3ba"
import script from "./ConfHiopos.vue?vue&type=script&lang=js"
export * from "./ConfHiopos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28d6b3ba')) {
      api.createRecord('28d6b3ba', component.options)
    } else {
      api.reload('28d6b3ba', component.options)
    }
    module.hot.accept("./ConfHiopos.vue?vue&type=template&id=28d6b3ba", function () {
      api.rerender('28d6b3ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/administration/ConfHiopos.vue"
export default component.exports